import React from "react";
import { Container, Row, Col } from "reactstrap";

class Preview extends React.Component {
  runWidgetPreview() {
    const initWidget = function(widget, id) {
      widgetLoading(widget, true);

      const urlAttribute = 'data-dpg-rss-url';
      const url = document.querySelectorAll('[' + urlAttribute + ']')[0].getAttribute(urlAttribute);

      const serverCall = new XMLHttpRequest();

      serverCall.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
          buildWidget(widget, id, this.responseText);
          widgetLoading(widget, false);
        }
      };

      serverCall.open('GET', `${url}wp-json/dpg/v1/load-widget?id=${id}`, true);
      serverCall.send();
    }

    const widgetLoading = function(widget, isLoading) {
      if(isLoading) {
        const loaderElement = document.createElement('div');

        loaderElement.innerHTML = 'Laden...';
        loaderElement.setAttribute('class', 'dpg-rss-feed__loader');
        loaderElement.setAttribute('id', 'loader');

        widget.appendChild(loaderElement);
      } else {
        const loaderElement = widget.querySelector('#loader');

        loaderElement.parentNode.removeChild(loaderElement);
      }
    }

    const matchesData = function(data, guid) {
      let isTrue = false;

      if(data !== undefined && data !== null && data.length > -1) {
        data.forEach((singleItem) => {
          if(guid === singleItem.guid) {
            isTrue = true;
          }
        });
      }

      return isTrue;
    }

    const buildWidget = function(widget, id, response) {
      const responseObj = JSON.parse(response);
      const data = responseObj.data;

      // Show disabled notice if widget is disabled
      const enabled = data.enabled;
      if(!enabled || data.status !== 'publish') {
        disableWidget(widget);

        return false;
      }

      // Merge and sort feeds
      let feeds = mergeFeeds(data.feeds, widget);
      feeds = sortFeeds(feeds, data.sticky);
      feeds = feeds.slice(0, data.amount);

      if(data.feeds === false) {
        return false;
      }
      // Create container with feeds
      const container = document.createElement('div');
      container.setAttribute('style', `border-color: ${data.colors.border_color}; background-color: ${data.colors.background_color};`);
      container.setAttribute('class', 'dpg-rss-feed__container');

      // Main title
      const mainTitle = document.createElement('h3');
      mainTitle.innerHTML = data.title;
      mainTitle.setAttribute('class', 'dpg-rss-feed__main-title');
      mainTitle.setAttribute('style', `color: ${data.colors.title_color};`);

      feeds.forEach((item, i) => {
        const skipItem = matchesData(data.hidden, item.guid);
        const isFeatured = matchesData(data.sticky, item.guid);

        // Child container
        const child = document.createElement('a');
        child.setAttribute('style', `border-bottom-color: ${data.colors.border_color};`);
        child.setAttribute('href', item.link + '?utm_source=' + window.location.host + '&utm_medium=partner-referral');
        child.setAttribute('target', '__blank');
        child.setAttribute('class', 'dpg-rss-feed__child');

        // Date: text
        let formattedDate = new Date(item.pubDate);
        const months = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];

        formattedDate = (item.pubDate === undefined || item.pubDate === null ? false : formattedDate.getDate() + ' ' + months[formattedDate.getMonth()] + ' ' + formattedDate.getFullYear() + ' ' + formattedDate.getHours() + ':' +  ('0' + formattedDate.getMinutes()).slice(-2));
        const dateText = (formattedDate !== false ? document.createTextNode(formattedDate) : null);

        // Date: element
        const date = document.createElement('p');

        if(formattedDate !== false) {
          date.setAttribute('style', `color: ${data.colors.date_color};`);
          date.setAttribute('class', 'dpg-rss-feed__date');
          date.appendChild(dateText);
        }

        // Featured flag: text
        const featured = document.createElement('div');
        featured.setAttribute('style', `color: ${data.colors.label_text_color}; background-color: ${data.colors.label_background_color};`);
        featured.setAttribute('class', 'dpg-rss-feed__featured');
        featured.innerHTML = 'Uitgelicht';

        // Title: container
        const titleContainer = document.createElement('div');
        titleContainer.setAttribute('class', 'dpg-rss-feed__title-container');

        // Title: text
        const titleText = document.createTextNode(item.title);

        // Title: element
        const title = document.createElement('h4');
        title.setAttribute('style', `color: ${data.colors.title_color};`);
        title.setAttribute('class', 'dpg-rss-feed__title');
        title.appendChild(titleText);

        if(isFeatured) {
          title.prepend(featured);
        }

        // Description: text
        let descriptionText;

        if(typeof item.description === 'string') {
          descriptionText = document.createTextNode(item.description);
        } else {
          descriptionText = document.createTextNode('Dit bericht heeft geen beschrijving.');
        }

        // Description: element
        const description = document.createElement('p');
        description.setAttribute('style', `color: ${data.colors.decription_color};`);
        description.setAttribute('class', 'dpg-rss-feed__description');
        description.appendChild(descriptionText);

        // CTA: element
        const cta = document.createElement('p');
        cta.setAttribute('style', `color: ${data.colors.date_color};`);
        cta.setAttribute('class', 'dpg-rss-feed__cta');
        cta.innerHTML = 'Meer lezen...';

        // Image
        const image = document.createElement('img');
        image.setAttribute('src', data.brands[item.brandName].url);
        image.setAttribute('title', data.brands[item.brandName].title);
        image.setAttribute('height', '30px');
        image.setAttribute('class', 'dpg-rss-feed__image');

        // Child: apend elements to child
        if(formattedDate !== false) {
          child.appendChild(date);
        }

        titleContainer.appendChild(image);
        titleContainer.appendChild(title);
        child.appendChild(titleContainer);

        if(data.hide_text !== '1') {
          cta.setAttribute('class', 'dpg-rss-feed__cta dpg-rss-feed__cta--spacing');
          description.appendChild(cta);
          child.appendChild(description);
        } else {
          child.appendChild(cta);
        }

        // Container: append child to container
        if(!skipItem) {
          container.appendChild(child);
        }
      });
    
      if(data.show_title) {
        widget.appendChild(mainTitle);
      }

      widget.appendChild(container);

    }

    const disableWidget = function(widget) {
      // Disabled notice: text
      const titleText = document.createTextNode('Deze widget is momenteel niet beschikbaar');

      // Disabled notice: element
      const title = document.createElement('p');
      title.setAttribute('class', 'dpg-rss-feed__disabled');
      title.appendChild(titleText);

      widget.appendChild(title);
    }

    const mergeFeeds = function(feeds, widget) {
      let singleFeed = [];

      if(feeds === false) {
        disableWidget(widget);

        return [];
      }

      feeds.forEach((feed) => {
        const feedChannel = feed.data.channel;

        if(feedChannel.item !== undefined) {
          feedChannel.item.forEach((singleItem) => {
            singleItem.brandName = feed.feed_title;
          });

          const item = feedChannel.item;

          pushArray(singleFeed, item);
        }
      });

      return singleFeed;
    }

    const pushArray = function(arr, arr2) {
        arr.push.apply(arr, arr2);
    }

    const sortFeeds = function(feeds, sticky) {
      feeds.sort(function(a, b) {
        let comparison = new Date(b.pubDate) - new Date(a.pubDate);

        return comparison;
      });

      feeds.sort(function(a, b) {
        return matchesData(sticky, a.guid) ? -1 : matchesData(sticky, b.guid) ? 1 : 0;
      });

      return feeds;
    }

    document.querySelector('[data-dpg-rss-widget]').innerHTML = '';
    initWidget(document.querySelector('[data-dpg-rss-widget]'), document.querySelector('[data-dpg-rss-widget]').getAttribute('data-dpg-rss-widget'));
  }

  render() {
    return (
      <div>
        <div data-dpg-rss-widget={this.props.id} data-dpg-rss-url={this.props.url} className="dpg-rss-feed"></div>
      </div>
    );
  }
}

export default Preview;
